export default () => {
    return window.innerWidth <= 425 || window.innerHeight <= 425;
};
